import { store } from '../'
import { router } from '../../app';

const state = () => ({
    openMenu: '',
    productFetchError: '',
    currentProduct:{},
    editHistory: [
        {'id': 1, 'date': '2020-10-13', 'type': 'N/A', 'from': 'SOHO', 'to': 'BH', 'quantity': 1, 'amount': 'N/A'}
    ],
    productSkuSearch: null,
    productImageSrc: null,
    currentOffer:{},
    productOfferError: '',
    scannedItemOrder: '',
    scannedItemOffer: ''
    
});

const getters = {
    pageTitle: state => state.pageTitle,
    productSkuSearch: state => state.productSkuSearch,
    productFetchError: state => state.productFetchError,
    productOfferError: state => state.productOfferError,
    currentOffer: state => state.currentOffer
};

const mutations = {
    setTitle(state, title) {
        state.pageTitle = title;
    },
    setMenu(state, name) {
        state.openMenu = name;
    },
    setFetchError(state, error){
        state.productFetchError = error;
    },
    updateState(state, payload){ 
        //console.log('mutation called: '+ payload.field + ' = ' + payload.value);
        state[payload.field] = payload.value 
    }
};

const actions = {
    set({commit}, payload){ 
        //console.log('action called: '+ payload.field + ' = ' + payload.value);
        commit('updateState', {field: payload.field, value: payload.value}) 
    },
    calculatePrice({commit, state}, payload){
        console.log('calculate-price: '+Object.entries(payload))
        let calcCost = state.cost;
        let calcRetail = state.retail;
        if(payload.type == 'Adjusted Margin'){
            var newMargin = payload.value
            var newSalePrice = calcCost / (1 - (newMargin / 100));
            var newDiscount = ((calcRetail - newSalePrice) / calcRetail) * 100;
        }else if(payload.type == 'Added Discount'){
            var newDiscount = payload.value
            var newSalePrice = calcRetail - (calcRetail * (newDiscount / 100));
            var newMargin = ((newSalePrice - calcCost) / newSalePrice) * 100;
        }else if(payload.type == 'Current Price'){
            var newSalePrice = payload.value
            var newMargin = ((newSalePrice - calcCost) / newSalePrice) * 100;
            var newDiscount = ((calcRetail - newSalePrice) / calcRetail) * 100;
        }
        commit('updateState',{field: 'currentPrice', value: parseFloat(newSalePrice).toFixed(0)});
        commit('updateState',{field: 'adjustedMargin', value: parseFloat(newMargin).toFixed(0)});
        commit('updateState',{field: 'addedDiscount', value: parseFloat(newDiscount).toFixed(0)});
    },
    parseFetched({commit, rootGetters, state}, payload){
        return new Promise((resolve, reject) => {
            if(!payload.response[payload.searchSku]) 
                reject(new Error('SKU did not return a product'));
            //console.log('ParseFetched: response: ' + Object.entries(payload.response[payload.searchSku]) );
            var parsed = payload.response[payload.searchSku];
            //console.log('sku-based response: ');
            for (const property in parsed) {
               // console.log('property? ' + `${property}: ${parsed[property]}`);
                let propName = `${property.replace('__c', '').replaceAll('_', '').charAt(0).toLowerCase()}${property.replace('__c', '').replaceAll('_', '').substr(1, property.length)}`
                    //console.log('final propname:' +propName);
                    let newValue = parsed[property];
                    switch(propName){
                        case 'shortDescription': propName = 'productName'; break;
                        case 'sKU': propName = 'productSku'; break;
                        case 'retailPrice': propName = 'msrp'; break;
                        case 'imageURL': propName = 'productImageSrc';
                                         store.dispatch('ItemInfo/updateImageCollection', newValue);
                                         break;
                        case 'vendorCountry': propName = 'vendorLocation'; break;
                        case 'subCategory': propName = 'subcategory'; break;
                        case 'countryofOrigin': propName = 'origin'; break;
                        case 'buyer': propName = 'buyers'; break;
                        case 'wholesalePrice': propName = 'currentPrice'; break
                        case 'wholesaleDiscount': propName = 'addedDiscount'; break;
                        default: break;
                }
                store.commit('ItemInfo/updateState', {field: propName, value: parsed[property]} )
            }
            store.dispatch('ItemInfo/calculatePrice', {type: 'Current Price', value: store.getters['ItemInfo/currentPrice']})
            //console.log('end location response: ' + payload.storeLocation);
            if(payload.storeLocation == 'ItemCard'){
                if(router.currentRoute.name != 'ItemCard'){
                    router.push('/item-card');
                }
            }
        });
    },
    fetchSimpleItemInfo({commit, getters, dispatch}, payload){
        return new Promise((resolve, reject) => {
            let searchSku = payload.sku;
            let storeLocation = payload.store;
            //console.log('checking sku - ', payload)
            let myItem = this._vm.$api.get('/api/itemCard/sku/' + searchSku)
            .then((response) =>{
                //console.log('response - ', response)
                if (response.length == 0){
                    reject("No Matching Item Found")
                }else{
                    resolve(response);
                }
            })
            .catch((error) => {
                commit('setFetchError', error)
                console.log('is this the same message? error retrieving product from sku: ' + error);
                reject(error)
            });
            
        });
    },
    fetchItem({commit, getters, dispatch}, payload){
        commit('setFetchError', '')
        store.commit('ItemInfo/updateState', {field:'productImages', value: []})

        return new Promise((resolve, reject) => {
            let searchSku = payload.sku;
            let storeLocation = payload.store;
            //console.log('checking sku - ', payload)
            let myItem = this._vm.$api.get('/api/itemCard/sku/' + searchSku)
            .then((response) => {
                //console.log('before parsing - ', response);
                dispatch('parseFetched', {response, searchSku, storeLocation})
                /*.then(() =>{
                    console.log('to set notification?')
                    //store.dispatch('ItemCard/setNotification', searchSku, { root: true });
                })*/
                .catch((error) => {
                    commit('setFetchError', error)
                        console.log('is this the same message? error retrieving product from sku: ' + error);
                    reject(error)
                });
                //console.log("errors? - "+ getters.productFetchError);
                
            });
            resolve(myItem);
                
        });
    },
    fetchItemHistory({commit, getters, dispatch}, payload){
        let searchSku = payload;
        return this._vm.$api.get('/api/itemCard/transactionHistory/' + searchSku)
            .then((response) => {
                //console.log('itemHistory:',JSON.stringify(response));
                return response
            });

    },
    fetchOfferInventoryData({commit, getters, dispatch}, payload){
        let searchSku = payload;
        //console.log('calling Offer inventory data', searchSku);
        return new Promise((resolve, reject) => {
            this._vm.$api.get('/api/itemCard/getOfferInventoryData/' + encodeURIComponent(searchSku))
            .then((response) => {
                //console.log('itemInventoryData:',JSON.stringify(response));
                dispatch('set', {field: 'currentOffer', value: response});
                resolve(response)
            })
            .catch((error) => {
                dispatch('set', {field:'productOfferError', value: error});
                dispatch('set', {field: 'currentOffer', value: {}});
                //console.log('is this the same message? offer data?: ' + error);
                reject(error);
            });
        });
    },
    fetchSavedItem({commit, dispatch, rootGetters}, payload){
        let collection = rootGetters['ProductCollection/productCollection'];
        //console.log('collection: '+ collection)
        let currentProduct = collection[collection.findIndex(x => x.productSku == payload.sku)]
        //console.log('currentProduct: '+ Object.entries(currentProduct));
        for (const property in currentProduct) {
            // console.log('property? ' + `${property}: ${parsed[property]}`);
             let propName = `${property.replace('__c', '').replaceAll('_', '').charAt(0).toLowerCase()}${property.replace('__c', '').replaceAll('_', '').substr(1, property.length)}`
                 //console.log('final propname:' +propName);
                 let newValue = currentProduct[property];
                 switch(propName){
                     case 'shortDescription': propName = 'productName'; break;
                     case 'sKU': propName = 'productSku'; break;
                     case 'retailPrice': propName = 'msrp'; break;
                     case 'imageURL': propName = 'productImageSrc';
                                      store.dispatch('ItemInfo/updateImageCollection', newValue);
                                      break;
                     case 'vendorCountry': propName = 'vendorLocation'; break;
                     case 'subCategory': propName = 'subcategory'; break;
                     case 'countryofOrigin': propName = 'origin'; break;
                     case 'buyer': propName = 'buyers'; break;
                     case 'wholesalePrice': propName = 'currentPrice'; break
                     case 'wholesaleDiscount': propName = 'addedDiscount'; break;
                     default: break;
             }
             store.commit('ItemInfo/updateState', {field: propName, value: currentProduct[property]} )
         }
         store.dispatch('ItemInfo/calculatePrice', {type: 'Current Price', value: store.getters['ItemInfo/currentPrice']})
         if(router.currentRoute.name != 'ItemCard'){
             router.push('/item-card');
         }

    },
    setPageValidation({commit, dispatch, state}, payload){
        if(router.currentRoute.name != 'ItemCard'){
            router.push('/item-card');
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
  }